import {InjectionToken} from '@angular/core';
import {SseConfig} from './sse-config.interface';

export const SSE_CONFIG = new InjectionToken<SseConfig>('SSE_CONFIG');
